import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiHelpCircle, FiLogOut, FiHeart } from 'react-icons/fi';
import { IoWalletOutline, IoCashOutline, IoCardOutline, IoPrintOutline } from 'react-icons/io5';

const CatCardPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-uc-navy text-white">
      {/* Header */}
      <div className="flex items-center justify-between p-4 border-b border-gray-700">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 bg-white"></div>
          <div className="text-xs">
            <div className="font-bold">CAT CARD</div>
            <div className="text-gray-300">MOBILE</div>
          </div>
        </div>
        <button className="text-uc-gold">
          <FiHelpCircle size={24} />
        </button>
      </div>

      {/* UC Merced Branding */}
      <div className="px-4 py-3 text-sm font-semibold tracking-wide">
        UC MERCED
      </div>

      {/* Main Card Container */}
      <div className="px-4 py-6">
        <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-lg p-6 shadow-xl">
          {/* Card Display Area */}
          <div className="flex items-center justify-between mb-6">
            {/* Left side - PERSEVERE text */}
            <div className="flex-1">
              <div className="text-white text-xl font-bold tracking-widest opacity-70">
                PERSEVERE
              </div>
            </div>

            {/* Right side - Profile Photo */}
            <div className="ml-4">
              <img
                src="/profile_image.png"
                alt="Profile"
                className="w-24 h-24 rounded-full border-4 border-white object-cover"
              />
            </div>
          </div>

          {/* Name and Pay Button */}
          <div className="text-center mt-4">
            <p className="text-white text-lg font-semibold mb-3">Dhilip Raman</p>
            <button className="border-2 border-uc-gold text-uc-gold px-8 py-1.5 rounded font-bold text-sm hover:bg-uc-gold hover:text-uc-navy transition-colors">
              PAY
            </button>
          </div>
        </div>

        {/* Action Buttons Grid */}
        <div className="grid grid-cols-3 gap-4 mt-8">
          {/* Add Funds */}
          <button className="flex flex-col items-center gap-2 p-4 hover:bg-gray-800 rounded-lg transition-colors relative">
            <div className="relative">
              <div className="w-12 h-12 border-2 border-uc-gold rounded-full flex items-center justify-center">
                <IoWalletOutline className="text-uc-gold" size={24} />
              </div>
              <div className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full"></div>
            </div>
            <span className="text-xs text-white">Add Funds</span>
          </button>

          {/* Balance */}
          <button className="flex flex-col items-center gap-2 p-4 hover:bg-gray-800 rounded-lg transition-colors">
            <div className="w-12 h-12 border-2 border-uc-gold rounded-full flex items-center justify-center">
              <IoCashOutline className="text-uc-gold" size={24} />
            </div>
            <span className="text-xs text-white">Balance</span>
          </button>

          {/* iCare */}
          <button className="flex flex-col items-center gap-2 p-4 hover:bg-gray-800 rounded-lg transition-colors">
            <div className="w-12 h-12 border-2 border-uc-gold rounded-full flex items-center justify-center">
              <FiHeart className="text-uc-gold" size={24} />
            </div>
            <span className="text-xs text-white">iCare</span>
          </button>

          {/* Lost My Card */}
          <button className="flex flex-col items-center gap-2 p-4 hover:bg-gray-800 rounded-lg transition-colors">
            <div className="w-12 h-12 border-2 border-uc-gold rounded-full flex items-center justify-center">
              <IoCardOutline className="text-uc-gold" size={24} />
            </div>
            <span className="text-xs text-white">Lost My Card</span>
          </button>

          {/* Bites/Prints */}
          <button className="flex flex-col items-center gap-2 p-4 hover:bg-gray-800 rounded-lg transition-colors">
            <div className="w-12 h-12 border-2 border-uc-gold rounded-full flex items-center justify-center">
              <IoPrintOutline className="text-uc-gold" size={24} />
            </div>
            <span className="text-xs text-white">Bites/Prints</span>
          </button>

          {/* Log out */}
          <button
            onClick={() => navigate('/home')}
            className="flex flex-col items-center gap-2 p-4 hover:bg-gray-800 rounded-lg transition-colors"
          >
            <div className="w-12 h-12 border-2 border-uc-gold rounded-full flex items-center justify-center">
              <FiLogOut className="text-uc-gold" size={24} />
            </div>
            <span className="text-xs text-white">Log out</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default CatCardPage;
